// extracted by mini-css-extract-plugin
export default {"title":"RequestedStampsInfoTable_title__6MGxb","fontSize":"RequestedStampsInfoTable_fontSize__kh8BM"};